import { useRef, useEffect, useCallback } from "react";
function useResolvedElement(subscriber, refOrElement) {
  const lastReportRef = useRef(null);
  const refOrElementRef = useRef(null);
  refOrElementRef.current = refOrElement;
  const cbElementRef = useRef(null);
  useEffect(() => {
    evaluateSubscription();
  });
  const evaluateSubscription = useCallback(() => {
    const cbElement = cbElementRef.current;
    const refOrElement2 = refOrElementRef.current;
    const element = cbElement || // eslint-disable-next-line no-nested-ternary
    (refOrElement2 ? refOrElement2 instanceof Element ? refOrElement2 : refOrElement2.current : null);
    if (lastReportRef.current && lastReportRef.current.element === element && lastReportRef.current.subscriber === subscriber) {
      return;
    }
    if (lastReportRef.current && lastReportRef.current.cleanup) {
      lastReportRef.current.cleanup();
    }
    lastReportRef.current = {
      element,
      subscriber,
      cleanup: element ? subscriber(element) : void 0
    };
  }, [subscriber]);
  useEffect(() => {
    return () => {
      if (lastReportRef.current && lastReportRef.current.cleanup) {
        lastReportRef.current.cleanup();
        lastReportRef.current = null;
      }
    };
  }, []);
  return useCallback(
    (element) => {
      cbElementRef.current = element;
      evaluateSubscription();
    },
    [evaluateSubscription]
  );
}
export {
  useResolvedElement
};
